import { Styles } from 'react-jss'

export const sheet: Styles = {
  root: {
    display: 'flex',
    padding: 20,
    justifyContent: 'center'
  }
}
